module.exports = "https://bin.bnbstatic.com/_next/static/images/mac-019578938b65eae4307f53106c5917e0.png";